import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import ContactServices from "../services/contactServices";

const Contact = () => {
  const [contactData, setContactData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchContacts = async () => {
      try {
        const data = await ContactServices.getAllContacts();
        // assuming you only want the first contact for display
        setContactData(data[0] || null);
      } catch (err) {
        setError("Failed to load contact info");
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchContacts();
  }, []);

  if (loading) return <p>Loading contact info...</p>;
  if (error) return <p>{error}</p>;
  if (!contactData) return <p>No contact info found.</p>;

  return (
    <section className="contact py-80">
      <div className="container container-lg">
        <div className="row gy-5">
          {/* Contact Form */}
          <div className="col-lg-8">
            <div className="contact-box border border-gray-100 rounded-16 px-24 py-40">
              <form>
                <h6 className="mb-32">Make Custom Request</h6>
                <div className="row gy-4">
                  <div className="col-sm-6 col-xs-6">
                    <label className="flex-align gap-4 text-sm fw-semibold mb-4">
                      Full Name <span className="text-danger">*</span>
                    </label>
                    <input type="text" className="common-input px-16" placeholder="Full name" />
                  </div>
                  <div className="col-sm-6 col-xs-6">
                    <label className="flex-align gap-4 text-sm fw-semibold mb-4">
                      Email Address <span className="text-danger">*</span>
                    </label>
                    <input type="email" className="common-input px-16" placeholder="Email address" />
                  </div>
                  <div className="col-sm-6 col-xs-6">
                    <label className="flex-align gap-4 text-sm fw-semibold mb-4">
                      Phone Number <span className="text-danger">*</span>
                    </label>
                    <input type="number" className="common-input px-16" placeholder="Phone Number" />
                  </div>
                  <div className="col-sm-6 col-xs-6">
                    <label className="flex-align gap-4 text-sm fw-semibold mb-4">
                      Subject <span className="text-danger">*</span>
                    </label>
                    <input type="text" className="common-input px-16" placeholder="Subject" />
                  </div>
                  <div className="col-sm-12">
                    <label className="flex-align gap-4 text-sm fw-semibold mb-4">
                      Message <span className="text-danger">*</span>
                    </label>
                    <textarea className="common-input px-16" placeholder="Type your message" />
                  </div>
                  <div className="col-sm-12 mt-32">
                    <button type="submit" className="btn btn-main py-18 px-32 rounded-8">
                      Get a Quote
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>

          {/* Contact Info */}
          <div className="col-lg-4">
            <div className="contact-box border border-gray-100 rounded-16 px-24 py-40">
              <h6 className="mb-48">Get In Touch</h6>
              <div className="flex-align gap-16 mb-16">
                <span className="w-40 h-40 flex-center rounded-circle border bg-main-600 text-white text-2xl">
                  <i className="ph-fill ph-phone-call" />
                </span>
                <Link to={`tel:${contactData.phone_number}`} className="text-md text-gray-900 hover-text-main-600">
                  {contactData.phone_number}
                </Link>
              </div>
              <div className="flex-align gap-16 mb-16">
                <span className="w-40 h-40 flex-center rounded-circle border bg-main-600 text-white text-2xl">
                  <i className="ph-fill ph-envelope" />
                </span>
                <Link to={`mailto:${contactData.gmail}`} className="text-md text-gray-900 hover-text-main-600">
                  {contactData.gmail}
                </Link>
              </div>
              <div className="flex-align gap-16 mb-0">
                <span className="w-40 h-40 flex-center rounded-circle border bg-main-600 text-white text-2xl">
                  <i className="ph-fill ph-map-pin" />
                </span>
                <span className="text-md text-gray-900">{contactData.office_address}</span>
              </div>
            </div>

            <div className="mt-24 flex-align flex-wrap gap-16">
              <Link to="#" className="bg-neutral-600 hover-bg-main-600 rounded-8 p-10 px-16 flex-between flex-wrap gap-8 flex-grow-1">
                <span className="text-white fw-medium">Get Support On Call</span>
                <span className="w-36 h-36 bg-main-600 rounded-8 flex-center text-xl text-white">
                  <i className="ph ph-headset" />
                </span>
              </Link>
              <Link to="#" className="bg-neutral-600 hover-bg-main-600 rounded-8 p-10 px-16 flex-between flex-wrap gap-8 flex-grow-1">
                <span className="text-white fw-medium">Get Direction</span>
                <span className="w-36 h-36 bg-main-600 rounded-8 flex-center text-xl text-white">
                  <i className="ph ph-map-pin" />
                </span>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;